import { DisabledPrompt, useRoute } from "@bcm-dev/bcms-vite";
import React from 'react';
import "./mobile.css";

/**
 * @function MobileColumnAdWidget
 * @return {React.Component}
 * @exported true
 * @description This is the column ad widget for mobile. 
 * This ad is currently branded through demo MABI23.
 */

export default function MobileColumnAdWidget(props) {
  const navigate = useRoute();
  const adImageURL = props.adImageURL ?? "";
  //const brandingColorName = props.brandingColorName ?? "";
  const adLinkURL = props.adLinkURL ?? "";
  let hasAdLinkURL = (adLinkURL === "" || adLinkURL === undefined) ? false : true;
  // The string needs to be of some type of url.
  if(!adLinkURL.includes("http")) hasAdLinkURL = false;
  let adLinkURLIsInCurrABI22 = false;

  if(hasAdLinkURL && adLinkURL.includes("/bcms/click/abi22/")) {
    adLinkURLIsInCurrABI22 = true;
  }

  // If the ad is enabled, then we will either route to a component or open a new window,
  // depending on if the url set in branding is in "/bcms/click/abi22/" or not.
  const onClick = () => {
    if(adLinkURLIsInCurrABI22) {
      const urlHash = "#/";
      const indexOfURLHash = adLinkURL.indexOf(urlHash);
      const route = "/" + adLinkURL.substring(indexOfURLHash + urlHash.length);
      navigate(route);
    } else {
      window.open(adLinkURL);
    }
  };

  return (
    <>
    { hasAdLinkURL &&
      <div className="mobile-column-ad-widget clickable flex-container flex-horizontal align-center justify-center" onClick={ onClick }>
          <img
          src={ adImageURL }
          />
      </div>
    }
    { !hasAdLinkURL &&
    <div>
      <DisabledPrompt>
        <div className="mobile-column-ad-widget clickable clickable flex-container flex-horizontal align-center justify-center" onClick={ onClick }>
            <img
            src={ adImageURL }
            />
        </div>
      </DisabledPrompt>
    </div>
    }
    </>
  );
}